import { Storage } from '@iheartjane/utils';

interface CacheArgs {
  phone: string | null;
  storeId: number | string;
}

export const authCodeCacheKey = ({ phone, storeId }: CacheArgs): string => {
  const str = `${phone}:${storeId}`;
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return (hash >>> 0).toString(36);
};

export const getCachedAuthCode = (cacheArgs: CacheArgs): string | undefined =>
  Storage.get<string>(authCodeCacheKey(cacheArgs));

export const setCachedAuthCode = (cacheArgs: CacheArgs, authCode: string) =>
  Storage.set(authCodeCacheKey(cacheArgs), authCode);

export const removeCachedAuthCode = (cacheArgs: CacheArgs) =>
  Storage.remove(authCodeCacheKey(cacheArgs));
